import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../firebase";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [userType, setUserType] = useState(null);
	const [designation, setDesignation] = useState(null);
  const [loadingInitial, setLoadingInitial] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(
    () =>
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        user.getIdTokenResult().then((res) => {
          setUserType(res.claims.userType);
          setDesignation(res.claims.designation);
        });
      } else {
        setUser(null);
      }
      setLoadingInitial(false);
    }),
  []
  );

  const logout = () => {
    setLoading(true);
    signOut(auth);
    setLoading(false);
  };

  const loginWithEmailAndPassword = async (email, password) => {
    setLoading(true);
    try {
      const credential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
    } catch (e) {}
    setLoading(false);
  };

  const registerWithEmailAndPassword = async (email, password) => {
    setLoading(true);
    try {
      const credential = await createUserWithEmailAndPassword(
        auth, 
        email,
        password
      );
    } catch (e) {}
    setLoading(false);
  };

  const memoValues = useMemo(
    () => ({
      user,
      loading,
      loginWithEmailAndPassword,
      registerWithEmailAndPassword,
      logout,
      userType,
			designation,
    }),
    [user, loading,userType,designation]
  );
  return (
    <AuthContext.Provider value={memoValues}>
      {!loadingInitial && children}
    </AuthContext.Provider>
  );
};

export default function useAuth() {
  return useContext(AuthContext);
}
